import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import { EditorAuthProvider } from "@/context/EditorAuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import SearchMaid from "@/pages/SearchMaid";
import Biodata from "@/pages/Biodata";
import Application from "@/pages/Application";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import EditorLogin from "@/pages/editor/EditorLogin";
import EditorDashboard from "@/pages/editor/EditorDashboard";
import ArticleEditor from "@/pages/editor/ArticleEditor";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <EditorAuthProvider>
        <LangProvider>
        <BrowserRouter>
          <Toaster richColors position="top-center" />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/search-maid" element={<SearchMaid />} />
              <Route path="/biodata/:id" element={<Biodata />} />
              <Route path="/application" element={<Application />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/editor/login" element={<EditorLogin />} />
            <Route path="/editor" element={<EditorDashboard />} />
            <Route path="/editor/articles/:id" element={<ArticleEditor />} />
          </Routes>
        </BrowserRouter>
        </LangProvider>
        </EditorAuthProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
